<app-modal-header>
  <div class="flex grow items-center">
    <div class="flex items-center">
      <svg-icon src="assets/icons/icon-megaphone-2.svg" class="my-1 w-8 text-amber-500"></svg-icon>
      <p translate class="hidden pl-3 text-lg font-semibold text-amber-500 md:block">geral.comunicados</p>
    </div>
    <hr app-modal-divider class="border-left-[1px] m-0 mx-5 h-full border border-solid border-zinc-100 lg:block" />
    <p class="whitespace-nowrap px-1 text-lg font-medium">{{ data.communication.title }}</p>
  </div>
</app-modal-header>
<div app-modal-content class="flex h-[70vh] w-[80vw] px-4!">
  <div class="flex w-full h-full flex-col rounded-lg bg-gray-100">
    <div class="mb-2 px-4 pt-6">
      <div class="flex justify-between gap-1 md:gap-0 flex-col md:flex-row">
        <div class="flex min-w-max flex-col">
          <p class="text-md">
            <b class="text-md text-base-gray-500" translate>geral.data-geral</b>
            {{ data.communication.date | date: 'dd/MM/yyyy' }}
          </p>
          @if (data.communication.author) {
            <p class="text-md">
              <b class="text-md text-base-gray-500" translate>geral.autor-geral</b> {{ data.communication.author }}
            </p>
          }
        </div>
      </div>
    </div>
    <div class="flex flex-wrap items-center px-4">
      @for (groupings of data.communication.communication_groupings; track groupings.grouping?.id) {
        <span class="mb-2 mr-2 whitespace-nowrap rounded-full bg-base-ea-400 px-4 text-white">
          {{ groupings.grouping?.descricao }}
        </span>
      }
    </div>
    @if (allAttachments.length) {
      <div
        class="flex w-full shrink-0 items-center gap-2 border-b border-gray-100 overflow-x-auto no-scrollbar bg-gray-100 px-4"
      >
        @for (attachment of allAttachments; track $index) {
          <button
            (click)="onOpenAttachment(attachment)"
            class="flex cursor-pointer items-center gap-3 whitespace-nowrap px-4 py-3 transition-all relative group"
            [ngClass]="
              dataViewer()?.name === attachment.title ? 'text-modules-eclass-500' : 'text-gray-500 hover:text-gray-700'
            "
          >
            <svg-icon class="w-5" [src]="icon(attachment.extension)"></svg-icon>
            <span class="text-sm font-semibold">{{ attachment.title }}</span>

            @if (dataViewer()?.name === attachment.title) {
              <div class="absolute bottom-0 left-0 h-1 w-full rounded-t-full bg-modules-eclass-500"></div>
            } @else {
              <div
                class="absolute bottom-0 left-0 h-1 w-0 rounded-t-full bg-gray-200 transition-all group-hover:w-full"
              ></div>
            }
          </button>
        }
      </div>
    }
    <div class="min-h-0 w-full grow overflow-y-auto">
      @if (dataViewer()) {
        <div class="w-full h-full px-4">
          <app-file-viewer [data]="dataViewer()"></app-file-viewer>
        </div>
      }
    </div>
  </div>
</div>
